import React, { useState, useEffect } from 'react';
import './App.css';
import Logo from './components/Logo';
import DarkModeToggle from './components/DarkModeToggle';
import FilterOptions from './components/FilterOptions';

const positionPlayers = [
  {
    name: "Walker Jenkins",
    position: "OF",
    rank: 1,
    level: "AA",
    age: 20,
    stats: { avg: ".362", obp: ".417", slg: ".571", ops: ".988", bb_k: "0.67", wrc: "165" }
  },
  {
    name: "Emmanuel Rodriguez",
    position: "OF",
    rank: 2,
    level: "AA",
    age: 22,
    stats: { avg: ".274", obp: ".400", slg: ".500", ops: ".900", bb_k: "1.00", wrc: "145" }
  },
  {
    name: "Luke Keaschall",
    position: "2B/OF",
    rank: 3,
    level: "AA",
    age: 22,
    stats: { avg: ".290", obp: ".365", slg: ".470", ops: ".835", bb_k: "0.80", wrc: "130" }
  },
  {
    name: "Kaelen Culpepper",
    position: "3B",
    rank: 4,
    level: "A+",
    age: 22,
    stats: { avg: ".285", obp: ".355", slg: ".450", ops: ".805", bb_k: "0.75", wrc: "125" }
  },
  {
    name: "Brandon Winokur",
    position: "SS",
    rank: 7,
    level: "A",
    age: 20,
    stats: { avg: ".275", obp: ".345", slg: ".440", ops: ".785", bb_k: "0.70", wrc: "120" }
  },
  {
    name: "Billy Amick",
    position: "3B",
    rank: 14,
    level: "A",
    age: 22,
    stats: { avg: ".265", obp: ".335", slg: ".420", ops: ".755", bb_k: "0.60", wrc: "110" }
  },
  {
    name: "Rayne Doncon",
    position: "3B/SS",
    rank: 15,
    level: "A+",
    age: 21,
    stats: { avg: ".260", obp: ".330", slg: ".410", ops: ".740", bb_k: "0.55", wrc: "105" }
  },
  {
    name: "Ricardo Olivar",
    position: "C/OF",
    rank: 17,
    level: "AA",
    age: 23,
    stats: { avg: ".255", obp: ".325", slg: ".400", ops: ".725", bb_k: "0.50", wrc: "100" }
  },
  {
    name: "Gabriel Gonzalez",
    position: "OF",
    rank: 18,
    level: "A+",
    age: 21,
    stats: { avg: ".250", obp: ".320", slg: ".390", ops: ".710", bb_k: "0.45", wrc: "95" }
  },
  {
    name: "Eduardo Beltre",
    position: "OF",
    rank: 19,
    level: "A",
    age: 19,
    stats: { avg: ".245", obp: ".315", slg: ".380", ops: ".695", bb_k: "0.40", wrc: "90" }
  },
  {
    name: "Yasser Mercedes",
    position: "OF",
    rank: 20,
    level: "A",
    age: 20,
    stats: { avg: ".240", obp: ".310", slg: ".370", ops: ".680", bb_k: "0.35", wrc: "85" }
  },
  {
    name: "Kala'i Rosario",
    position: "OF",
    rank: 21,
    level: "AA",
    age: 22,
    stats: { avg: ".235", obp: ".305", slg: ".360", ops: ".665", bb_k: "0.30", wrc: "80" }
  },
  {
    name: "Peyton Eeles",
    position: "2B",
    rank: 23,
    level: "AAA",
    age: 25,
    stats: { avg: ".230", obp: ".300", slg: ".350", ops: ".650", bb_k: "0.25", wrc: "75" }
  },
  {
    name: "Diego Cartaya",
    position: "C",
    rank: 24,
    level: "AAA",
    age: 23,
    stats: { avg: ".225", obp: ".295", slg: ".340", ops: ".635", bb_k: "0.20", wrc: "70" }
  },
  {
    name: "Dameury Pena",
    position: "2B/OF",
    rank: 25,
    level: "ROK",
    age: 19,
    stats: { avg: ".220", obp: ".290", slg: ".330", ops: ".620", bb_k: "0.15", wrc: "65" }
  },
  {
    name: "Danny De Andrade",
    position: "SS",
    rank: 26,
    level: "A+",
    age: 20,
    stats: { avg: ".215", obp: ".285", slg: ".320", ops: ".605", bb_k: "0.10", wrc: "60" }
  },
  {
    name: "Santiago Leon",
    position: "SS",
    rank: 27,
    level: "ROK",
    age: 16,
    stats: { avg: ".210", obp: ".280", slg: ".310", ops: ".590", bb_k: "0.05", wrc: "55" }
  },
  {
    name: "Khadim Diaw",
    position: "C",
    rank: 30,
    level: "A",
    age: 21,
    stats: { avg: ".205", obp: ".275", slg: ".300", ops: ".575", bb_k: "0.00", wrc: "50" }
  }
];

const pitchers = [
  {
    name: "Connor Prielipp",
    position: "LHP",
    rank: 5,
    level: "AA",
    age: 24,
    stats: { era: "3.25", whip: "1.15", k_9: "11.2", bb_9: "2.8", k_bb: "4.0", fip: "3.10", record: "8-4" }
  },
  {
    name: "Marco Raya",
    position: "RHP",
    rank: 6,
    level: "AAA",
    age: 22,
    stats: { era: "3.45", whip: "1.18", k_9: "10.8", bb_9: "3.0", k_bb: "3.6", fip: "3.25", record: "7-5" }
  },
  {
    name: "Charles Soto",
    position: "RHP",
    rank: 8,
    level: "A",
    age: 19,
    stats: { era: "3.60", whip: "1.22", k_9: "10.5", bb_9: "3.2", k_bb: "3.3", fip: "3.40", record: "6-4" }
  },
  {
    name: "Andrew Morris",
    position: "RHP",
    rank: 9,
    level: "AAA",
    age: 23,
    stats: { era: "3.75", whip: "1.25", k_9: "10.2", bb_9: "3.4", k_bb: "3.0", fip: "3.55", record: "8-6" }
  },
  {
    name: "C.J. Culpepper",
    position: "RHP",
    rank: 10,
    level: "AA",
    age: 23,
    stats: { era: "3.85", whip: "1.28", k_9: "10.0", bb_9: "3.5", k_bb: "2.9", fip: "3.65", record: "7-5" }
  },
  {
    name: "Cory Lewis",
    position: "RHP",
    rank: 11,
    level: "AAA",
    age: 24,
    stats: { era: "3.90", whip: "1.30", k_9: "9.8", bb_9: "3.6", k_bb: "2.7", fip: "3.75", record: "8-7" }
  },
  {
    name: "Desan Hill",
    position: "LHP",
    rank: 13,
    level: "ROK",
    age: 19,
    stats: { era: "4.00", whip: "1.32", k_9: "9.5", bb_9: "3.8", k_bb: "2.5", fip: "3.85", record: "5-3" }
  },
  {
    name: "Elberson Castellano",
    position: "RHP",
    rank: 16,
    level: "MLB",
    age: 23,
    stats: { era: "4.10", whip: "1.35", k_9: "9.2", bb_9: "4.0", k_bb: "2.3", fip: "3.95", record: "6-6" }
  },
  {
    name: "Travis Adams",
    position: "RHP",
    rank: 22,
    level: "AAA",
    age: 25,
    stats: { era: "4.20", whip: "1.38", k_9: "8.9", bb_9: "4.2", k_bb: "2.1", fip: "4.05", record: "7-8" }
  },
  {
    name: "Adrian Bohorquez",
    position: "RHP",
    rank: 28,
    level: "A",
    age: 20,
    stats: { era: "4.30", whip: "1.40", k_9: "8.6", bb_9: "4.4", k_bb: "2.0", fip: "4.15", record: "5-5" }
  },
  {
    name: "Jose Olivares",
    position: "RHP",
    rank: 29,
    level: "A+",
    age: 22,
    stats: { era: "4.40", whip: "1.42", k_9: "8.4", bb_9: "4.5", k_bb: "1.9", fip: "4.25", record: "6-7" }
  }
];

function App() {
  const [positionSort, setPositionSort] = useState({ field: 'rank', direction: 'asc' });
  const [pitcherSort, setPitcherSort] = useState({ field: 'rank', direction: 'asc' });
  const [currentPage, setCurrentPage] = useState('prospects');
  const [isDarkMode, setIsDarkMode] = useState(() => {
    const savedMode = localStorage.getItem('darkMode');
    return savedMode ? JSON.parse(savedMode) : false;
  });
  const [filters, setFilters] = useState({
    position: 'All',
    level: 'All',
    ageRange: 'All Ages'
  });

  useEffect(() => {
    localStorage.setItem('darkMode', JSON.stringify(isDarkMode));
    document.body.classList.toggle('dark-mode', isDarkMode);
  }, [isDarkMode]);

  const toggleDarkMode = () => {
    setIsDarkMode(prev => !prev);
  };

  const handleFilterChange = (filterType, value) => {
    setFilters(prev => ({
      ...prev,
      [filterType]: value
    }));
  };

  const clearFilters = () => {
    setFilters({
      position: 'All',
      level: 'All',
      ageRange: 'All Ages'
    });
  };

  const filterPlayers = (players) => {
    return players.filter(player => {
      if (filters.position === 'All' && filters.level === 'All' && filters.ageRange === 'All Ages') {
        return true;
      }

      const matchesPosition = filters.position === 'All' || player.position.includes(filters.position);
      const matchesLevel = filters.level === 'All' || player.level === filters.level;
      
      let matchesAge = true;
      if (filters.ageRange !== 'All Ages') {
        const age = player.age;
        switch (filters.ageRange) {
          case 'Under 20':
            matchesAge = age < 20;
            break;
          case '20-22':
            matchesAge = age >= 20 && age <= 22;
            break;
          case '23-25':
            matchesAge = age >= 23 && age <= 25;
            break;
          case 'Over 25':
            matchesAge = age > 25;
            break;
          default:
            matchesAge = true;
        }
      }

      return matchesPosition && matchesLevel && matchesAge;
    });
  };

  const sortPlayers = (players, sortConfig) => {
    return [...players].sort((a, b) => {
      let aValue = sortConfig.field.includes('stats.') 
        ? a.stats[sortConfig.field.split('.')[1]]
        : a[sortConfig.field];
      let bValue = sortConfig.field.includes('stats.')
        ? b.stats[sortConfig.field.split('.')[1]]
        : b[sortConfig.field];

      if (typeof aValue === 'string') {
        aValue = aValue.toLowerCase();
        bValue = bValue.toLowerCase();
      }

      if (aValue < bValue) return sortConfig.direction === 'asc' ? -1 : 1;
      if (aValue > bValue) return sortConfig.direction === 'asc' ? 1 : -1;
      return 0;
    });
  };

  const filteredPositionPlayers = filterPlayers(positionPlayers);
  const filteredPitchers = filterPlayers(pitchers);
  const sortedPositionPlayers = sortPlayers(filteredPositionPlayers, positionSort);
  const sortedPitchers = sortPlayers(filteredPitchers, pitcherSort);

  const renderProspectCard = (player) => {
    const isPitcher = player.position.includes('HP');
    return (
      <div key={player.rank} className="profile-card" role="article">
        <div className="rank-badge">#{player.rank}</div>
        <h3 className="card-name">{player.name}</h3>
        <div className="card-info">
          <div className="info-row">
            <span className="info-label">Position:</span>
            <span className="info-value">{player.position}</span>
          </div>
          <div className="info-row">
            <span className="info-label">Age:</span>
            <span className="info-value">{player.age}</span>
          </div>
          <div className="info-row">
            <span className="info-label">Level:</span>
            <span className="info-value">{player.level}</span>
          </div>
        </div>
        <div className="stats-container">
          {isPitcher ? (
            <>
              <div className="stat-row">
                <div className="stat-column">
                  <div className="stat-header">ERA</div>
                  <div className="stat-value">{player.stats.era}</div>
                  <div className="stat-subtext">FIP</div>
                  <div className="stat-subvalue">{player.stats.fip}</div>
                </div>
                <div className="stat-column">
                  <div className="stat-header">WHIP</div>
                  <div className="stat-value">{player.stats.whip}</div>
                  <div className="stat-subtext">BB/9</div>
                  <div className="stat-subvalue">{player.stats.bb_9}</div>
                </div>
                <div className="stat-column">
                  <div className="stat-header">K/9</div>
                  <div className="stat-value">{player.stats.k_9}</div>
                  <div className="stat-subtext">RECORD</div>
                  <div className="stat-subvalue">{player.stats.record}</div>
                </div>
              </div>
            </>
          ) : (
            <>
              <div className="stat-row">
                <div className="stat-column">
                  <div className="stat-header">AVG</div>
                  <div className="stat-value">{player.stats.avg}</div>
                  <div className="stat-subtext">OBP</div>
                  <div className="stat-subvalue">{player.stats.obp}</div>
                </div>
                <div className="stat-column">
                  <div className="stat-header">SLG</div>
                  <div className="stat-value">{player.stats.slg}</div>
                  <div className="stat-subtext">OPS</div>
                  <div className="stat-subvalue">{player.stats.ops}</div>
                </div>
                <div className="stat-column">
                  <div className="stat-header">BB/K</div>
                  <div className="stat-value">{player.stats.bb_k}</div>
                  <div className="stat-subtext">wRC+</div>
                  <div className="stat-subvalue">{player.stats.wrc}</div>
                </div>
              </div>
            </>
          )}
        </div>
      </div>
    );
  };

  const handleSort = (field, isPosition = true) => {
    if (isPosition) {
      setPositionSort(prev => {
        if (prev.field === field) {
          return { field, direction: prev.direction === 'asc' ? 'desc' : 'asc' };
        } else {
          return { field, direction: 'asc' };
        }
      });
    } else {
      setPitcherSort(prev => {
        if (prev.field === field) {
          return { field, direction: prev.direction === 'asc' ? 'desc' : 'asc' };
        } else {
          return { field, direction: 'asc' };
        }
      });
    }
  };

  const renderSortIcon = (field, sortConfig) => {
    if (sortConfig.field === field) {
      if (sortConfig.direction === 'asc') {
        return <>&#8597;</>;
      } else {
        return <>&#8593;</>;
      }
    } else {
      return <>&#8595;</>;
    }
  };

  const renderFilters = () => (
    <div className="filter-controls-wrapper">
      <div className="filter-controls">
        <div className="filter-group">
          <label className="filter-label">Position:</label>
          <select
            className="filter-select"
            value={filters.position}
            onChange={(e) => handleFilterChange('position', e.target.value)}
          >
            <option value="All">All</option>
            <option value="Pitchers">Pitching</option>
            <option value="Position">Hitters</option>
          </select>
        </div>
        <div className="filter-group">
          <label className="filter-label">Level:</label>
          <select
            className="filter-select"
            value={filters.level}
            onChange={(e) => handleFilterChange('level', e.target.value)}
          >
            <option value="All">All</option>
            <option value="MLB">MLB</option>
            <option value="AAA">AAA</option>
            <option value="AA">AA</option>
            <option value="A+">A+</option>
            <option value="A">A</option>
            <option value="ROK">Rookie</option>
          </select>
        </div>
        <div className="filter-group">
          <label className="filter-label">Age Range:</label>
          <select
            className="filter-select"
            value={filters.ageRange}
            onChange={(e) => handleFilterChange('ageRange', e.target.value)}
          >
            <option value="All Ages">All Ages</option>
            <option value="Under 20">Under 20</option>
            <option value="20-22">20-22</option>
            <option value="23-25">23-25</option>
            <option value="Over 25">Over 25</option>
          </select>
        </div>
        <button className="clear-filters" onClick={clearFilters}>
          Clear Filters
        </button>
      </div>
    </div>
  );

  const renderDetailedStatsFilters = () => (
    <div className="filter-controls-wrapper">
      <div className="filter-controls">
        <div className="filter-group">
          <label className="filter-label">Position:</label>
          <select
            className="filter-select"
            value={filters.position}
            onChange={(e) => handleFilterChange('position', e.target.value)}
          >
            <option value="All">All</option>
            <option value="Pitchers">Pitching</option>
            <option value="Position">Hitters</option>
          </select>
        </div>
        <div className="filter-group">
          <label className="filter-label">Level:</label>
          <select
            className="filter-select"
            value={filters.level}
            onChange={(e) => handleFilterChange('level', e.target.value)}
          >
            <option value="All">All</option>
            <option value="MLB">MLB</option>
            <option value="AAA">AAA</option>
            <option value="AA">AA</option>
            <option value="A+">A+</option>
            <option value="A">A</option>
            <option value="ROK">Rookie</option>
          </select>
        </div>
        <button className="clear-filters" onClick={clearFilters}>
          Clear Filters
        </button>
      </div>
    </div>
  );

  const renderSortButtons = () => (
    <div className="sort-controls">
      <button
        className={`sort-button ${positionSort.field === 'rank' ? 'active' : ''}`}
        onClick={() => handleSort('rank')}
      >
        Rank
        <span className="sort-icon">{renderSortIcon('rank', positionSort)}</span>
      </button>
      <button
        className={`sort-button ${positionSort.field === 'age' ? 'active' : ''}`}
        onClick={() => handleSort('age')}
      >
        Age
        <span className="sort-icon">{renderSortIcon('age', positionSort)}</span>
      </button>
      <button
        className={`sort-button ${positionSort.field === 'stats.avg' ? 'active' : ''}`}
        onClick={() => handleSort('stats.avg')}
      >
        AVG
        <span className="sort-icon">{renderSortIcon('stats.avg', positionSort)}</span>
      </button>
      <button
        className={`sort-button ${positionSort.field === 'stats.ops' ? 'active' : ''}`}
        onClick={() => handleSort('stats.ops')}
      >
        OPS
        <span className="sort-icon">{renderSortIcon('stats.ops', positionSort)}</span>
      </button>
      <button
        className={`sort-button ${positionSort.field === 'stats.wrc' ? 'active' : ''}`}
        onClick={() => handleSort('stats.wrc')}
      >
        wRC+
        <span className="sort-icon">{renderSortIcon('stats.wrc', positionSort)}</span>
      </button>
    </div>
  );

  return (
    <div className={`App ${isDarkMode ? 'dark-mode' : ''}`}>
      <header className="App-header">
        <div className="header-top">
          <Logo />
          <DarkModeToggle isDarkMode={isDarkMode} onToggle={toggleDarkMode} />
        </div>
        <h1>Minnesota Twins Top Prospects</h1>
        <p>Tracking the Future Stars of Twins Territory</p>
        <nav className="main-nav">
          <button 
            className={`nav-button ${currentPage === 'prospects' ? 'active' : ''}`}
            onClick={() => setCurrentPage('prospects')}
          >
            Top Prospects
          </button>
          <button 
            className={`nav-button ${currentPage === 'stats' ? 'active' : ''}`}
            onClick={() => setCurrentPage('stats')}
          >
            Detailed Stats
          </button>
          <button 
            className={`nav-button ${currentPage === 'guide' ? 'active' : ''}`}
            onClick={() => setCurrentPage('guide')}
          >
            Stats Guide
          </button>
        </nav>
      </header>

      <main className="main-content">
        {currentPage === 'prospects' ? (
          <section className="prospects-section">
            <div className="section-intro">
              <p className="section-description">
                Meet the next generation of Minnesota Twins talent. Our top prospects are ranked based on scouting reports, performance, and potential impact.
              </p>
              <p className="data-source">
                Prospect rankings and data sourced from <a href="https://www.mlb.com/milb/prospects/twins/" target="_blank" rel="noopener noreferrer">MLB.com's Twins Top Prospects list</a>.
              </p>
            </div>

            <h2 className="section-title">Top Prospects</h2>
            
            {renderFilters()}

            <div className="profile-cards-container" role="list">
              {[...sortedPositionPlayers, ...sortedPitchers]
                .sort((a, b) => a.rank - b.rank)
                .map(renderProspectCard)}
            </div>
          </section>
        ) : currentPage === 'stats' ? (
          <section className="stats-section">
            <div className="section-intro">
              <h2>The Numbers Behind Tomorrow's Stars</h2>
              <p className="section-description">
                Baseball is a game of numbers, each telling its own story. From classic stats to modern analytics,
                these numbers tell the story of Minnesota's next generation. Sort any column to discover hidden gems and rising talents.
              </p>
            </div>

            <div className="stats-container">
              <div className="stats-group">
                <h3>Hitting Prospects</h3>
                {renderSortButtons()}
                <div className="stats-table-container">
                  <table className="stats-table">
                    <thead>
                      <tr>
                        <th>Rank</th>
                        <th>Name</th>
                        <th>Position</th>
                        <th>Level</th>
                        <th>Age</th>
                        <th>AVG</th>
                        <th>OBP</th>
                        <th>SLG</th>
                        <th>OPS</th>
                        <th>wRC+</th>
                      </tr>
                    </thead>
                    <tbody>
                      {sortedPositionPlayers.map(player => (
                        <tr key={player.rank}>
                          <td>{player.rank}</td>
                          <td>{player.name}</td>
                          <td>{player.position}</td>
                          <td>{player.level}</td>
                          <td>{player.age}</td>
                          <td>{player.stats.avg}</td>
                          <td>{player.stats.obp}</td>
                          <td>{player.stats.slg}</td>
                          <td>{player.stats.ops}</td>
                          <td>{player.stats.wrc}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>

              <div className="stats-group">
                <h3>Pitching Prospects</h3>
                <div className="sort-controls" role="toolbar" aria-label="Sort pitchers">
                  <button onClick={() => handleSort('rank', false)} className="sort-button">
                    Rank {renderSortIcon('rank', pitcherSort)}
                  </button>
                  <button onClick={() => handleSort('age', false)} className="sort-button">
                    Age {renderSortIcon('age', pitcherSort)}
                  </button>
                  <button onClick={() => handleSort('stats.era', false)} className="sort-button">
                    ERA {renderSortIcon('stats.era', pitcherSort)}
                  </button>
                  <button onClick={() => handleSort('stats.k_9', false)} className="sort-button">
                    K/9 {renderSortIcon('stats.k_9', pitcherSort)}
                  </button>
                  <button onClick={() => handleSort('stats.whip', false)} className="sort-button">
                    WHIP {renderSortIcon('stats.whip', pitcherSort)}
                  </button>
                </div>
                <div className="stats-table-container">
                  <table className="stats-table">
                    <thead>
                      <tr>
                        <th>Rank</th>
                        <th>Name</th>
                        <th>Position</th>
                        <th>Level</th>
                        <th>Age</th>
                        <th>ERA</th>
                        <th>G</th>
                        <th>IP</th>
                        <th>K/9</th>
                        <th>BB/9</th>
                        <th>WHIP</th>
                      </tr>
                    </thead>
                    <tbody>
                      {sortedPitchers.map(player => (
                        <tr key={player.rank}>
                          <td>{player.rank}</td>
                          <td>{player.name}</td>
                          <td>{player.position}</td>
                          <td>{player.level}</td>
                          <td>{player.age}</td>
                          <td>{player.stats.era}</td>
                          <td>{player.stats.games}</td>
                          <td>{player.stats.ip}</td>
                          <td>{player.stats.k_9}</td>
                          <td>{player.stats.bb_9}</td>
                          <td>{player.stats.whip}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </section>
        ) : (
          <section className="guide-section">
            <div className="section-intro">
              <h2>Inside the Numbers: A Baseball Statistician's Guide</h2>
              <p className="section-description">
                Baseball is a game of numbers, each telling its own story. From classic stats to modern analytics,
                this guide helps you understand what makes a prospect truly special. Whether you're tracking the next 
                big power hitter or a future ace, these metrics reveal the full picture of player development.
              </p>
            </div>

            <div className="guide-content">
              <div className="stat-category">
                <h3>The Art of Hitting</h3>
                <div className="stat-explanation">
                  <h4>AVG (Batting Average) - The Classic Measure</h4>
                  <p>The foundation of hitting metrics. A .300 average puts a prospect in elite company, showing consistent barrel control and the ability to find gaps. While the league average hovers around .250, top prospects often distinguish themselves with averages well above this mark, especially at advanced levels.</p>
                </div>
                <div className="stat-explanation">
                  <h4>OBP (On-base Percentage) - Getting On Base</h4>
                  <p>The mark of a complete hitter. A .350 OBP demonstrates advanced plate discipline and the ability to work counts - skills that translate well to the major leagues. This stat combines hits, walks, and HBP, showing a prospect's total ability to reach base and create scoring opportunities.</p>
                </div>
                <div className="stat-explanation">
                  <h4>SLG (Slugging Percentage) - Raw Power</h4>
                  <p>Watch this number for future power hitters. A .450+ SLG suggests a prospect with the ability to drive the ball with authority. Singles count for 1.000, doubles 2.000, triples 3.000, and home runs 4.000 - making this the best measure of a hitter's raw power and extra-base potential.</p>
                </div>
                <div className="stat-explanation">
                  <h4>OPS (On-base Plus Slugging) - The Complete Picture</h4>
                  <p>The gold standard for offensive evaluation. An .800+ OPS prospect is showing both discipline and power - a combination that excites scouts. At .900+, you're looking at a potential impact bat, especially if sustained at higher levels. This combines the patience of OBP with the power of SLG.</p>
                </div>
                <div className="stat-explanation">
                  <h4>BB/K (Walk to Strikeout Ratio) - The Eye Test</h4>
                  <p>A crucial predictor of major league success. A ratio above 0.5 shows advanced pitch recognition, while 0.75+ suggests elite plate discipline. In today's high-velocity game, prospects who can control the strike zone often become valuable major league contributors.</p>
                </div>
                <div className="stat-explanation">
                  <h4>wRC+ (Weighted Runs Created Plus) - Context is King</h4>
                  <p>The modern metric that levels the playing field. 100 represents league average, with each point above showing how much better a prospect is performing. This stat adjusts for ballpark and league effects, making it perfect for comparing prospects across different levels and environments.</p>
                </div>
              </div>

              <div className="stat-category">
                <h3>The Science of Pitching</h3>
                <div className="stat-explanation">
                  <h4>ERA (Earned Run Average) - Run Prevention</h4>
                  <p>The traditional benchmark for pitching success. While sub-3.50 ERAs are excellent at the MLB level, remember that minor league ERAs tend to run higher. Focus on how a prospect's ERA compares to their league average and how it improves as they advance levels.</p>
                </div>
                <div className="stat-explanation">
                  <h4>WHIP (Walks + Hits per Inning Pitched) - Command & Control</h4>
                  <p>A window into a pitcher's efficiency. Elite prospects often post WHIPs under 1.20, showing their ability to limit baserunners. Anything over 1.40 raises red flags about control or contact management, though young power pitchers may improve this with development.</p>
                </div>
                <div className="stat-explanation">
                  <h4>K/9 (Strikeouts per Nine Innings) - The Swing & Miss</h4>
                  <p>In today's strikeout-heavy game, this is crucial. A K/9 above 9.0 suggests a pitcher with plus stuff and the ability to miss bats - a skill that typically translates well to higher levels. Power pitching prospects often excel here, even if other metrics need refinement.</p>
                </div>
                <div className="stat-explanation">
                  <h4>BB/9 (Walks per Nine Innings) - Command Artist</h4>
                  <p>Control is key to pitching success. A BB/9 under 3.0 shows promising command, while under 2.0 is exceptional. Young pitchers who can already paint the corners often have a head start on their development curve.</p>
                </div>
                <div className="stat-explanation">
                  <h4>FIP (Fielding Independent Pitching) - The True Test</h4>
                  <p>Looking beyond the box score. This ERA-like metric focuses on what pitchers directly control: strikeouts, walks, HBP, and home runs. When FIP is significantly lower than ERA, it might indicate a pitcher is performing better than traditional stats suggest - a potential hidden gem.</p>
                </div>
                <div className="stat-explanation">
                  <h4>W-L (Win-Loss Record) - The Team Context</h4>
                  <p>While wins and losses don't tell the whole story, they provide context. A winning record despite a struggling team can highlight mental toughness, while a mediocre record on a strong team might warrant deeper investigation into other metrics.</p>
                </div>
              </div>

              <div className="stat-category">
                <div className="scouting-intro">
                  <h3>The Complete Scouting Picture</h3>
                  <p>
                    Beyond the box scores lies the true art of prospect evaluation. Here's your insider's guide 
                    to what professional scouts analyze when identifying tomorrow's stars.
                  </p>
                </div>
                <div className="scouting-grid">
                  <div className="scouting-card">
                    <h4><span className="scouting-icon">1</span>Age vs. Level</h4>
                    <p>A 19-year-old dominating Double-A tells a different story than a 24-year-old with similar numbers. 
                    The younger the prospect relative to their competition, the more promising their performance becomes.</p>
                  </div>

                  <div className="scouting-card">
                    <h4><span className="scouting-icon">2</span>League Context</h4>
                    <p>A .280 average in the pitcher-friendly Florida State League might be more impressive than .300 in the 
                    hitter-friendly Pacific Coast League. Always consider the environment.</p>
                  </div>

                  <div className="scouting-card">
                    <h4><span className="scouting-icon">3</span>Park Factors</h4>
                    <p>From the thin air of Albuquerque to the marine layer in San Diego, ballpark dimensions and conditions 
                    can dramatically impact a prospect's numbers. Look for consistency across different venues.</p>
                  </div>

                  <div className="scouting-card">
                    <h4><span className="scouting-icon">4</span>Sample Size</h4>
                    <p>A hot month is interesting, but sustained success over multiple seasons is compelling. 
                    Look for trends and improvements rather than short-term spikes.</p>
                  </div>

                  <div className="scouting-card">
                    <h4><span className="scouting-icon">5</span>Development Path</h4>
                    <p>Progressive improvement in key metrics often matters more than raw numbers. Watch for 
                    better plate discipline, increasing power, or improved command over time.</p>
                  </div>

                  <div className="scouting-card">
                    <h4><span className="scouting-icon">6</span>Tools & Skills</h4>
                    <p>Elite tools (speed, power, arm strength) with mediocre stats might suggest untapped potential. 
                    Conversely, strong numbers without standout tools could indicate a lower ceiling.</p>
                  </div>

                  <div className="scouting-card">
                    <h4><span className="scouting-icon">7</span>Competition Quality</h4>
                    <p>Success against other top prospects, especially in key matchups, carries extra weight. 
                    Pay attention to performance in advanced leagues and against ranked competition.</p>
                  </div>

                  <div className="scouting-card">
                    <h4><span className="scouting-icon">8</span>Injury History</h4>
                    <p>Past injuries can explain statistical anomalies and suggest future development patterns. 
                    Recovery time and performance after return are key indicators of long-term potential.</p>
                  </div>
                </div>
              </div>
            </div>
          </section>
        )}
      </main>
    </div>
  );
}

export default App;
